import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Simple SVG icons
const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-container">
          {/* Logo */}
          <div className="logo-container">
            <motion.div 
              className="logo"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <img src="/Logo.svg" alt="ЛингваСаб" height="40" />
            </motion.div>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav">
            <ul className="nav-list">
              <li>
                <a href="#features" className="nav-link pencil-text">Возможности</a>
              </li>
              <li>
                <a href="#how-it-works" className="nav-link pencil-text">Как это работает</a>
              </li>
              <li>
                <a href="#testimonials" className="nav-link pencil-text">Отзывы</a>
              </li>
              <li>
                <a href="#cta" className="nav-link pencil-text">Начать</a>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <div className="mobile-menu-container">
            <button 
              onClick={toggleMenu}
              className="mobile-menu-button"
              aria-label="Меню"
            >
              {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <motion.div 
          className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: isMenuOpen ? 1 : 0, height: isMenuOpen ? 'auto' : 0 }}
          transition={{ duration: 0.3 }}
        >
          <ul className="mobile-nav-list">
            <li>
              <a href="#features" onClick={toggleMenu}>Возможности</a>
            </li>
            <li>
              <a href="#how-it-works" onClick={toggleMenu}>Как это работает</a>
            </li>
            <li>
              <a href="#testimonials" onClick={toggleMenu}>Отзывы</a>
            </li>
            <li>
              <a href="#cta" onClick={toggleMenu}>Начать</a>
            </li>
          </ul>
        </motion.div>
      </div>
    </header>
  );
};

export default Header; 